<script setup>
import {useBaseStore} from "~/stores/base";
import {capsuleCreate} from "~/api/api.capsule";
import {Loading} from "@element-plus/icons-vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["save"])

/** props **/
const props = defineProps({
  swiperSlideIndex: {
    default: 0
  }
})

/** data **/
const name = ref("")
const isLoading = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const btnConfirmDisabled = computed(() => !name.value)

/** watch **/
watch(() => props.swiperSlideIndex, async () => {
  if (props.swiperSlideIndex === 1) {
    reset()
  }
})

/** methods **/
const handleSave = async () => {
  if (isLoading.value) return
  isLoading.value = true
  const res = await capsuleCreate({capsuleName: name.value})
  isLoading.value = false

  emits("save", {
    ...res.result,
    capsuleName: name.value,
    hasPo: 0,
    hasProduct: 0,
    productCount: 0,
    shopProductList: [],
  })
}
const reset = () => {
  name.value = ""
}

/** lifecycle **/

</script>

<template>
  <div class="module-create-capsule-mobile" v-if="isMobile">
<!--    <div class="tips">Use any combo of ABCs, 123s, symbols or emojis</div>-->
    <div class="input">
      <module-input
        :title="'Name Your Capsule'"
        :placeholder="'Think Date Night Fits or Back to Office'"
        v-model="name"
        :max-length="40"
      />
    </div>
    <div class="btn-primary" :class="{'btn-disabled': btnConfirmDisabled || isLoading}" @click="handleSave">
      <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
        <Loading/>
      </el-icon>
      <span>save</span>
    </div>
  </div>
  <div class="module-create-capsule-desktop" v-else>
<!--    <div class="tips">Use any combo of ABCs, 123s, symbols or emojis</div>-->
    <div class="input">
      <module-input
        :title="'Name Your Capsule'"
        :placeholder="'Think Date Night Fits or Back to Office'"
        v-model="name"
        :max-length="40"
      />
    </div>
    <div class="btn-primary" :class="{'btn-disabled': btnConfirmDisabled || isLoading}" @click="handleSave">
      <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
        <Loading/>
      </el-icon>
      <span>save</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-create-capsule-mobile {
  height: 100%;
  position: relative;

  .tips {
    padding: 10px;

    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */

    text-align: center;
  }

  .input {
    margin-top: 20px;
    padding: 64px 1px 0 1px;
  }

  .btn-primary {
    width: 100%;
    position: absolute;
    transform: translate(-50%, 0);
    left: 50%;
    bottom: 50px;
  }
}

.module-create-capsule-desktop {
  padding: 0 16px 72px 16px;

  .tips {
    padding: 10px;

    color: $color-gray-800;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px; /* 142.857% */

    text-align: center;
  }

  .input {
    margin-top: 20px;
    padding: 64px 1px 0 1px;
  }

  .btn-primary {
    margin-top: 158px;
  }
}
</style>
